<template>
  <div class="container policy-basket--mobile hide-for-large">
    <div class="row mobile-top-price">
      <div class="small-6 columns" v-html="modelValue.CurrentPriceLabel" />
      <div
        :class="[
          'small-6 columns total-price--mobile price',
          { 'text-faded': editMode && anyChanges }
        ]"
      >
        {{ initialPriceFormatted }}
        <span
          v-if="isEditable"
          :class="{ editable: !editMode }"
          data-test-policy-activate-edit-mode-button-mobile
          @click="$store.dispatch('policy/activateEditMode', policyId)"
          v-html="modelValue.YourPricePaymentPeriodLabel"
        />
      </div>
    </div>
    <p
      data-test-price-disclaimer-mobile
      class="color-gray policy-basket--disclaimer"
      v-html="disclaimer"
    />

    <div v-if="editMode" class="mobile-new-price">
      <div class="container">
        <block-warning v-if="shouldBlock" v-model="basketErrorText" />
        <div v-if="anyChanges && !loading" class="row push-down">
          <div class="small-7 columns">
            <div v-html="modelValue.NewPriceLabel" />
            <div data-test-price-disclaimer-mobile class="color-gray" v-html="disclaimer" />
          </div>
          <div class="small-5 columns total-price--mobile price">
            {{ price }}
          </div>
        </div>

        <p
          v-if="hasAdditionalBasketProductInformationText"
          data-test-policy-basket-mobile-additional-basket-product-information-text
          v-html="additionalBasketProductInformationText"
        />

        <div class="row">
          <div class="small-6 columns">
            <button
              :disabled="!anyChanges || shouldBlock"
              class="button align-center"
              data-test-policy-basket-mobile-save-proposal-button
              @click="$store.dispatch('policy/confirmSaveProposal')"
              v-html="modelValue.SaveButton"
            />
          </div>
          <div class="small-6 columns">
            <button
              :data-test-policy-basket-mobile-cancel-proposal-button="portalId"
              class="button align-center secondary"
              @click="$store.dispatch('policy/cancelEditMode')"
              v-html="modelValue.CancelButton"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import BasketMixin from './_BasketMixin';
import BlockWarning from './BlockWarning.vue';

export default {
  name: 'MobileBasket',
  components: {
    BlockWarning
  },
  mixins: [BasketMixin],
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    },
    disclaimer: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    isEditable() {
      return this.$store.getters['policy/isEditable'];
    },
    portalId() {
      return this.$store.getters['policy/portalId'];
    }
  },
  watch: {
    editMode(val) {
      if (!val) {
        return;
      }

      const $elm = '.policy-editable-field';
      const mobilePriceElementHeight = $('.policy-basket--mobile').height() + 90;

      Utility.nextTickScroll($elm, this, mobilePriceElementHeight);
    }
  }
};
</script>
